// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CarHireTermsAndConditions-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/CarHireTermsAndConditions.mobile.scss
 ** module id = 903
 ** module chunks = 1
 **/